import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';

export const SubstitutionPlayerWrapper = styled.div`
  height: 36px;
  margin: 10px 7px;
  cursor: pointer;
`;

export const Player = styled.span`
  font-family: Lato;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: ${darkgrey};
`;
